import React from "react"
import { Search, RotateCcw, ChevronDown } from "lucide-react"

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: String(i),
  label: new Date(2000, i, 1).toLocaleDateString("en-US", { month: "long" }),
}))

const FilterSelect = ({ value, onChange, ariaLabel, children }) => (
  <div className={`reports-select-wrapper ${value !== "all" ? "has-value" : ""}`}>
    <select
      className="reports-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
    >
      {children}
    </select>
    <ChevronDown size={14} className="reports-select-caret" />
  </div>
)

const ReportsFilterBar = ({
  search,
  onSearchChange,
  year,
  onYearChange,
  years,
  month,
  onMonthChange,
  region,
  onRegionChange,
  regionOptions,
  reportType,
  onReportTypeChange,
  onClear,
}) => {
  return (
    <div className="reports-filter-bar">
      <div className="reports-search">
        <Search size={16} />
        <input
          type="text"
          placeholder="Search by week, region, topic..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <FilterSelect value={year} onChange={onYearChange} ariaLabel="Filter by year">
        <option value="all">Year</option>
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </FilterSelect>

      <FilterSelect value={month} onChange={onMonthChange} ariaLabel="Filter by month">
        <option value="all">Month</option>
        {MONTH_OPTIONS.map((m) => (
          <option key={m.value} value={m.value}>{m.label}</option>
        ))}
      </FilterSelect>

      <FilterSelect value={region} onChange={onRegionChange} ariaLabel="Filter by region">
        <option value="all">Region</option>
        {regionOptions.map((r) => (
          <option key={r.key} value={r.key}>{r.title}</option>
        ))}
      </FilterSelect>

      <FilterSelect value={reportType} onChange={onReportTypeChange} ariaLabel="Filter by report type">
        <option value="all">Report type</option>
        <option value="global">Global Impact</option>
        <option value="regional">Regional</option>
      </FilterSelect>

      <button type="button" className="reports-clear-btn" onClick={onClear}>
        <RotateCcw size={14} />
        Clear filters
      </button>
    </div>
  )
}

export default ReportsFilterBar
